import React from 'react';
import uniq from 'lodash/uniq';

import DollarPercent from './DollarsPercent';
import styled from 'styled-components';
import { RadioGroup } from './RadioGroup';

export default function SubGroup({
  responseType,
  options, value, onChange,
  total,
}) {
  const responseTypes = uniq(options.map(({ responseType }) => responseType));

  if (!responseType) {
    if (responseTypes.includes('radio')) {
      responseType = 'radio';
    } else if (responseTypes.length === 1) {
      responseType = responseTypes[0];
    }
  }

  switch(responseType) {
    case 'dollar_percent':
      return <DollarPercent
        {...{ value, onChange, total }}
      />;

    case 'radio':
      return <RadioSubGroup
        {...{ options, value, onChange }}
      />;

    case 'period':
      return null;

    default:
      return <div>ERROR! {responseType} not supported</div>;
  }
}

const RadioSubGroup = styled(RadioGroup)`
  margin-left: 50px;
  margin-top: 0 !important;
`;
